import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ClassesProvider } from "@/contexts/ClassesContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Analysis from "@/pages/Analysis";
import History from "@/pages/History";
import ExamDetail from "@/pages/ExamDetail";
import ExportPage from "@/pages/ExportPage";
import AdminUsers from "@/pages/AdminUsers";
import AdminClasses from "@/pages/AdminClasses";
import BatchUpload from "@/pages/BatchUpload";
import BatchHistory from "@/pages/BatchHistory";
import BatchDetail from "@/pages/BatchDetail";

function App() {
  return (
    <div className="App font-sans">
      <AuthProvider>
        <ClassesProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/analyze" element={<Analysis />} />
                <Route path="/batch" element={<BatchUpload />} />
                <Route path="/batches" element={<BatchHistory />} />
                <Route path="/batches/:id" element={<BatchDetail />} />
                <Route path="/history" element={<History />} />
                <Route path="/exam/:id" element={<ExamDetail />} />
                <Route
                  path="/export"
                  element={
                    <ProtectedRoute requireAdmin>
                      <ExportPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/users"
                  element={
                    <ProtectedRoute requireAdmin>
                      <AdminUsers />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/classes"
                  element={
                    <ProtectedRoute requireAdmin>
                      <AdminClasses />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
        </ClassesProvider>
      </AuthProvider>
      <Toaster theme="dark" position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
